<app-none-login-header></app-none-login-header>
<div class="not-found-container">
  <div class="not-found__title">404 NOT FOUND</div>
  <div class="not-found__sub-title">お探しのページは見つかりません</div>
  <div class="not-found__btn">
    <button 
      mat-stroked-button
      color="accent"
      class="app-btn"
      routerLink="/"
    >
      トップページへ
    </button>
  </div>

  <div class="not-found__image">
    <img src="https://pex-static.s3-ap-northeast-1.amazonaws.com/design/404image.png">
  </div>

</div>
<app-none-login-footer></app-none-login-footer>